import React from 'react'
import { use } from 'xadmin';

const LogoComponent = (props) => {
  const { settings } = use('settings')
  let logo = props?.type && props?.type == 'front' ? settings.reception_logo : settings.logo

  return (
    <>
      <img src={logo} className="guideImg"></img>
      <h3 className="guideTitle" dangerouslySetInnerHTML={{ __html: props?.type && props?.type == 'front' ? settings?.reception_name || settings?.name  : settings?.name || settings?.reception_name }} />
    </>
  )
}

export default LogoComponent
